var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUscLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 77,
    viewBox: "0 0 50 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3614 40.096V31.2877H42.1789L48.799 38.2065V46.928H39.685V40.096H37.3614ZM36.1978 43.2011L29.5777 50.12H24.7637V41.3117H27.0873V30.0755H8.50851L1.88839 23.1566V8.13799L8.51199 1.21914H29.5812L36.2013 8.14146V16.863H27.0873V10.0275H11.0024V21.2671H29.5777L36.1978 28.186V43.2046V43.2011ZM23.6001 40.096V66.976H39.685V60.144H48.799V68.869L42.1754 75.7878H21.1062L14.4861 68.869V38.21L21.1097 31.2911H25.9272V40.0995H23.6036L23.6001 40.096ZM13.326 50.12H8.50851L1.88839 43.2011V34.4796H11.0024V41.3117H13.326V50.12ZM49.9591 48.1437V37.7029L42.6582 30.072H37.3579V27.6789L30.057 20.048H12.1625V11.2397H25.9237V18.0717H37.3614V7.63088L30.0605 0H8.02919L0.728271 7.63088V23.6568L8.02919 31.2877H19.4669L13.3295 37.7029V40.096H12.1659V33.264H0.728271V43.7048L8.02919 51.3357H13.326V69.3691L20.6269 77H42.6582L49.9591 69.3691V58.9283H38.5215V65.7603H24.7602V51.3322H30.057L37.3579 43.7013V41.3082H38.518V48.1402H49.9557L49.9591 48.1437Z",
    fill: "#FFCD03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.685 46.928H48.7989V38.2065L42.1788 31.2877H37.3613V40.096H39.685V46.928Z",
    fill: "#9D2235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 21.2636V10.024H27.0873V16.856H36.1978V8.13449L29.5777 1.21564H8.51203L1.88843 8.13449V23.1531L8.50855 30.072H27.0873V41.3082H24.7637V50.12H29.5777L36.1978 43.2011V28.1825L29.5777 21.2636H11.0024Z",
    fill: "#9D2235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 34.4762H1.88843V43.1977L8.50855 50.12H13.326V41.3082H11.0024V34.4762Z",
    fill: "#9D2235"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9237 31.2877H21.1097L14.4861 38.203V38.2065V68.8655L21.1062 75.7843H42.1754L48.799 68.8655V60.144H39.685V66.976H23.6001V40.096H25.9237V31.2877Z",
    fill: "#9D2235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUscLogo);
export default __webpack_public_path__ + "static/media/usc_logo.7ebb4b574ae0bc7c7af5350e417c2b08.svg";
export { ForwardRef as ReactComponent };